<template>
<div>
    <!-- <el-select v-model="roundNo" placeholder="请选择" size="mini" v-if="basicFormData.times > 1" style="right: 8px; z-index: 1; width: 80px; position: absolute">
        <el-option v-for="index of basicFormData.times" :key="index" :label="index" :value="index"></el-option>
    </el-select> -->
    <div>
        <el-table :data="summaryList" :header-cell-style="{background:'#f5f5f5'}" border stripe size="mini">
            <el-table-column prop="rfqSupplierName" label="供应商名称" header-align="center" align="left" />
            <el-table-column prop="rfqSupplierCode" label="供应商编码" header-align="center" align="left" />
            <el-table-column prop="rfqContractMail" label="供应商邮箱" header-align="center" align="right" />
            <el-table-column prop="rfqSupplierReplyStatus" label="报价状态" header-align="center" align="center">
                <template slot-scope="scope">
                    <el-tag :type="getTagByStatus(scope.row.rfqSupplierReplyStatus)">
                        {{getStatus(scope.row.rfqSupplierReplyStatus)}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="targetPrice" label="目标价格" header-align="center" align="right" />
            <el-table-column prop="totalCost" label="未税总价" header-align="center" align="right">
                <template slot-scope="scope">
                    {{fixedNumber(scope.row.totalCost)}}
                </template>
            </el-table-column>
            <el-table-column fixed="right" v-if="!viewFlag" header-align="center" align="left" width="100" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showPrice(scope.row)" icon="el-icon-view">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <dlg-part-price v-if="dlgPartPriceVisible" ref="dlgPartPrice"></dlg-part-price>
</div>
</template>

<script>
import {
    getRfqPartViewList,
    getSupplierSummaryList
} from '@/controller/rfq'
import {
    RFQ_STATUS,
    USER_TYPE,
    QUOTATION_STATUS,
    getQUOTATION_STATUS_VALUE,
    getSUPPLY_RFQ_STATUS_VALUE,

} from '@/utils/const'
import moment from 'moment'
import DlgPartPrice from './rfq-dlg-part-price'
// require('@/mock/mockQuotation');
export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        supplierList: Array,
        viewFlag: Boolean
    },
    components: {
        DlgPartPrice,
    },
    data() {
        return {
            tableData: [],
            activeName: '',
            RFQ_STATUS: RFQ_STATUS,
            QUOTATION_STATUS: QUOTATION_STATUS,
            QUOTATION_STATUS_VALUE: getQUOTATION_STATUS_VALUE,
            viewData: {
                visible: false,
                width: ''
            },
            dlgPartPriceVisible: false,
            dataList: [],
            partList: [],
            priceList: [],
            summaryList: [],
            rfqSupplierReplyStatus: '',
            flowableType: '', //TODO:
            userInfo: '',
            roundNo: '1',
            USER_TYPE: USER_TYPE,
            currentPriceCode: '',
            currentPriceName: '',
            currentPriceIndex: 0,
            currentPriceCount: 0,
            flowParam: {
                flowTaskId: '',
                paramKey: '',
                paramVal: ''
            },
            dataRule: {},
        }
    },
    async mounted() {
        console.log('mounted')
        await this.initSummary()
    },
    methods: {
        getStatus(status) {
            return getQUOTATION_STATUS_VALUE(status)

        },
        getTagByStatus(status) {
            if (status === '1') {
                return 'info'
            } else if (status === '2') {
                return ''
            } else if (status === '3') {
                return 'danger'
            } else if (status === '4') {
                return 'success'
            } else if (status === '5') {
                return 'warning'
            }
        },

        async initSummary() {
            try {
                const parmas = {
                    rfqId: this.basicFormData.id,
                }
                const data = await getSupplierSummaryList(parmas)
                if (data && data.code === "00") {

                    const arr = data.body
                    this.summaryList = this.supplierList.map(v => {
                        const item = JSON.parse(JSON.stringify(v))
                        const obj = Object.assign(item, arr.find(v => v.rfqSupplierId === item.id) || {})
                        return obj
                    })
                } else {
                    this.summaryList = [];
                }
            } catch (e) {

            } finally {

            }
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 查所有供应商表
        getPriceList(id) {
            getRfqPartViewList({
                rfqId: this.basicFormData.id,
                rfqSupplierId: id,
                roundNo: this.roundNo
            }).then((data) => {
                if (data && data.code === "00") {
                    // this.partList = data.body.records;
                    this.partList = data.body;
                } else {
                    this.partList = [];
                }
            });
        },

        handleTabClick(tab, event) {
            this.getPriceList(this.supplierList[this.activeName].id)
        },
        async changeRoundNo(val) {
            console.log(this.roundNo)
            // TODO: 没有了
            // this.getSupplierSummaryList(this.basicFormData.id)
            await this.getPriceList(this.basicFormData.id)
        },
        showPrice(row) {
            this.dlgPartPriceVisible = true
            this.$nextTick(() => {
                this.$refs.dlgPartPrice.init(row, row ? row.rfqVenderId : 0, true)
            })
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            console.log(val)
            return Number(Number(val).toFixed(3))
        },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
